import type { PickProps, ReviewOption } from "./LeafTabs.types";

export function LeafRadioList({
  options,
  enginePick,
  picked,
  onPick,
}: PickProps & {
  options: ReviewOption[];
  enginePick?: string | null;
}) {
  if (options.length === 0)
    return <p className="text-sm text-slate-500">No leaves to show.</p>;
  return (
    <ul className="space-y-1">
      {options.map((option) => (
        <li key={option.key}>
          <label className="flex items-baseline gap-2 text-sm">
            <input
              type="radio"
              checked={picked === option.key}
              onChange={() => onPick(option.key)}
            />
            <span className="font-mono">{option.key}</span>
            {option.key === enginePick && (
              <span className="text-xs text-emerald-700">engine's pick</span>
            )}
            {option.description && (
              <span className="text-xs text-slate-500">
                {option.description}
              </span>
            )}
          </label>
        </li>
      ))}
    </ul>
  );
}
